// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget #footer_icon_legend .legend-icons{height:18px;width:18px}.eopoi-widget #footer_icon_legend .legend-icons.icon_blue{color:#50727c}.eopoi-widget #footer_icon_legend .legend-icons.icon_green{color:#64b968}.eopoi-widget #footer_icon_legend .legend-icons.icon_yellow{color:#e4cc37}.eopoi-widget #footer_icon_legend .legend-icons.icon_red{color:#af3e4d}.eopoi-widget #footer_icon_legend div[class^=col]{padding-top:0;padding-bottom:0}", ""]);
// Exports
module.exports = exports;
